import { render, staticRenderFns } from "./IconButtonCell.vue?vue&type=template&id=570983ac&scoped=true"
import script from "./IconButtonCell.vue?vue&type=script&lang=ts&setup=true"
export * from "./IconButtonCell.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570983ac",
  null
  
)

export default component.exports